document.addEventListener('DOMContentLoaded', () => {
  // ============================================================
  // CONFIG
  // ============================================================
  const SURCHARGE_VARIANTS = {
    pre10:    45887479316643,
    am:       45887621693603,
    pm:       45887621726371,
    specific: 45887621759139
  };

const STORAGE_KEY = 'grp_delivery_state_v2';
const SESSION_INIT_KEY = 'grp_delivery_session_initialized';
const DEFAULT_SLOT_LABEL = 'Standard delivery';
let deliveryPageLoadInitialised = false;
let deliveryPageInitialisationPromise = null;

  const minimogCartRefresh = (open = false) => {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open } }));
  };

  // ============================================================
  // DOM GETTERS (always fetch fresh; cart DOM gets replaced)
  // ============================================================
  const $ = (id) => document.getElementById(id);

  const els = () => ({
    res:        $('clarkes_residential'),
    date:       $('delivery_date'),
    slot:       $('time_slot'),
    specWrap:   $('specific-time-wrap'),
    specTime:   $('specific_time'),

    name:       $('delivery_contact_name'),
    tel:        $('delivery_contact_tel'),
    email:      $('tracker_email'),
    hours:      $('opening_hours'),
    extDoc:     $('external_document_no'),
    instr:      $('delivery_instructions'),

    weekdayMsg: $('weekday-msg'),
    cutoffMsg:  $('cutoff-msg'),
    timeErr:    $('spec-error'),
    resErr:     $('res-error'),
    upgradeSum: $('upgrade-summary'),
checkout:   $('custom-checkout-btn') || $('delivery-continue-btn')
  });

  const onCartPage = () => !!(els().slot && els().checkout);

  // ============================================================
  // HELPERS
  // ============================================================
function slotKey(v) {
  if (!v) return '';
  const lv = v.toLowerCase().trim();

  if (lv.includes('pre 10') || lv.includes('before 10')) return 'pre10';
  if (lv.includes('morning')) return 'am';
  if (lv.includes('afternoon')) return 'pm';
  if (lv === 'am' || lv.includes('am delivery')) return 'am';
  if (lv === 'pm' || lv.includes('pm delivery')) return 'pm';
  if (lv.includes('specific')) return 'specific';
  if (lv.includes('free') || lv.includes('standard')) return 'free';
  return '';
}

  function serviceLevelFromSlot(v) {
    const k = slotKey(v);
    switch (k) {
      case 'pre10':    return 'ND Pre 10';
      case 'am':       return 'ND AM';
      case 'pm':       return 'ND PM';
      case 'specific': return 'ND Specific time';
      case 'free':     return 'ND';
      default:         return '';
    }
  }

  const BANK_HOLIDAYS = new Set([
    '2026-08-31' // Summer Bank Holiday
  ]);

  function isWeekend(yyyyMmDd) {
    if (!yyyyMmDd) return false;
    const d = new Date(yyyyMmDd + 'T00:00:00');
    const day = d.getDay();
    return day === 0 || day === 6;
  }

  function isBankHoliday(yyyyMmDd) {
    return !!yyyyMmDd && BANK_HOLIDAYS.has(yyyyMmDd);
  }

  function isNonWorkingDateValue(yyyyMmDd) {
    return isWeekend(yyyyMmDd) || isBankHoliday(yyyyMmDd);
  }

  function readLocal() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}'); }
    catch { return {}; }
  }

  function writeLocal(state) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch {}
  }
function safeSessionGet(key) {
  try { return sessionStorage.getItem(key); } catch { return null; }
}

function safeSessionSet(key, value) {
  try { sessionStorage.setItem(key, value); } catch {}
}

function safeSessionRemove(key) {
  try { sessionStorage.removeItem(key); } catch {}
}

function isDeliverySessionInitialized() {
  return safeSessionGet(SESSION_INIT_KEY) === '1';
}

function markDeliverySessionInitialized() {
  safeSessionSet(SESSION_INIT_KEY, '1');
}

function clearDeliverySessionStateIfCartEmpty(cart) {
  if (cart && Array.isArray(cart.items) && cart.items.length === 0) {
    safeSessionRemove(SESSION_INIT_KEY);
  }
}

function setSlotFromLabel(label) {
  const hidden = document.getElementById('time_slot');
  if (hidden) hidden.value = label || '';

  const radios = document.querySelectorAll('input[name="time_slot_radio"]');
  radios.forEach((radio) => {
    radio.checked = radio.value === label;
    const option = radio.closest('.delivery-option');
    if (option) option.classList.toggle('is-selected', radio.checked);
  });
}

function isTypingSpecificTime() {
  const active = document.activeElement;
  return active && active.id === 'specific_time';
}

  // ============================================================
  // CART API
  // ============================================================
  async function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
  }

  async function saveAttrs(attrs, note) {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type':'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: attrs, note: note || '' })
    });
  }

function isSurchargeItem(it) {
  const variantId = Number(it.variant_id || it.id || 0);
  const sku = String(it.sku || '').toLowerCase();
  const ptype = String(it.product_type || '').toLowerCase();
  const vendor = String(it.vendor || '').toLowerCase();
  const title = String(it.product_title || it.title || '').toLowerCase();

  if (Object.values(SURCHARGE_VARIANTS).includes(variantId)) return true;
  if (ptype === 'delivery surcharge') return true;
  if (sku.startsWith('surcharge-')) return true;

  if (title === 'pre 10am') return true;
  if (title === 'before 10am') return true;
  if (title === 'am delivery') return true;
  if (title === 'morning (before 12pm)') return true;
  if (title === 'pm delivery') return true;
  if (title === 'afternoon (after 12pm)') return true;
  if (title === 'specific time') return true;
  if (title.includes('delivery upgrade')) return true;

  if (vendor === 'internal' && (ptype === 'delivery surcharge' || sku.includes('surcharge'))) return true;

  return false;
}

  async function removeAllSurcharges() {
    const cart = await fetchCart();
    const updates = {};
    cart.items.forEach(it => {
   if (isSurchargeItem(it)) {
  const variantId = Number(it.variant_id || it.id || 0);
  if (variantId) updates[variantId] = 0;
}
    });
    if (!Object.keys(updates).length) return;

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type':'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates })
    });
  }



  // ============================================================
  // UI + VALIDATION
  // ============================================================
  function buildStateFromUI() {
    const e = els();
    const slot = e.slot?.value || '';
    const specific = slotKey(slot) === 'specific' ? (e.specTime?.value || '') : '';

    return {
      clarkes_residential: e.res?.value || '',
      clarkes_delivery_date: e.date?.value || '',
      clarkes_time_slot: slot,
      clarkes_specific_time_value: specific,
      clarkes_delivery_contact_name: e.name?.value || '',
      clarkes_delivery_contact_tel: e.tel?.value || '',
      clarkes_tracker_email: e.email?.value || '',
      clarkes_opening_hours: e.hours?.value || '',
      external_document_no: e.extDoc?.value || '',
      clarkes_delivery_instructions: e.instr?.value || '',
      clarkes_service_level: serviceLevelFromSlot(slot) || ''
    };
  }

  function toggleSpecificUI() {
    const e = els();
    if (!e.slot || !e.specWrap || !e.specTime) return;

    if (slotKey(e.slot.value) === 'specific') {
      e.specWrap.style.display = 'block';
      e.specTime.min = '10:00';
      e.specTime.max = '17:00';
    } else {
      e.specWrap.style.display = 'none';
      e.specTime.value = '';
      if (e.timeErr) e.timeErr.textContent = '';
    }
  }

  function updateUpgradeSummary() {
    const e = els();
    if (!e.upgradeSum || !e.slot) return;

    const k = slotKey(e.slot.value);
    if (!k) { e.upgradeSum.textContent = ''; return; }
    if (k === 'free') { e.upgradeSum.textContent = 'Service level: ND (Next Day) — no delivery upgrade charge.'; return; }
    e.upgradeSum.textContent = `Service level: ${serviceLevelFromSlot(e.slot.value)}`;
  }

function formatGBP(amount) {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number(amount || 0));
}

function getCurrentVatMode() {
  const htmlMode = (document.documentElement.getAttribute('data-vat-mode') || '').trim().toLowerCase();
  const bodyMode = (document.body.getAttribute('data-vat-mode') || '').trim().toLowerCase();

  if (htmlMode === 'ex' || htmlMode === 'inc' || htmlMode === 'both') return htmlMode;
  if (bodyMode === 'ex' || bodyMode === 'inc' || bodyMode === 'both') return bodyMode;

  try {
    const keys = ['vat_mode', 'frk_vat_mode', 'grp_vat_mode', 'vat-display-mode', 'vatDisplayMode'];
    for (const key of keys) {
      const value = (localStorage.getItem(key) || '').trim().toLowerCase();
      if (value === 'ex' || value === 'inc' || value === 'both') return value;
    }
  } catch (e) {}

  return 'inc';
}

function updateDeliveryOptionPrices() {
  const nodes = document.querySelectorAll('[data-delivery-slot-price]');
  const vatMode = getCurrentVatMode();

  nodes.forEach((node) => {
    const base = Number(node.getAttribute('data-price-ex-vat') || 0);
    if (!base) return;

    const displayValue = vatMode === 'ex' ? base : base * 1.2;
    node.textContent = `+${formatGBP(displayValue)}`;
  });

  const vatLabel = document.getElementById('delivery-slot-vat-label');
  if (vatLabel) {
    vatLabel.textContent = vatMode === 'ex'
      ? 'Upgrade prices shown ex. VAT'
      : vatMode === 'both'
        ? 'Upgrade prices show both VAT views'
        : 'Upgrade prices shown inc. VAT';
  }
}

  function isValidSpecificTime() {
    const e = els();
    if (!e.slot) return true;
    if (slotKey(e.slot.value) !== 'specific') return true;
    const t = (e.specTime?.value || '').trim();
    if (!t) return false;
    return t >= '10:00' && t <= '17:00';
  }



/* ===============================
   Delivery Details Validation
=================================*/

function isDateBeforeMin(dateValue, minValue) {
  if (!dateValue || !minValue) return false;

  const chosen = new Date(dateValue + 'T00:00:00');
  const min = new Date(minValue + 'T00:00:00');

  return chosen < min;
}

function allValid() {
  const e = els();
  if (!e.date || !e.slot) return false;

  const hasDate = !!e.date.value;
  const isWorkingDate = hasDate && !isNonWorkingDateValue(e.date.value);
  const notBeforeMin = hasDate && !isDateBeforeMin(e.date.value, e.date.min);

  const dateOk = hasDate && isWorkingDate && notBeforeMin;
  const slotOk = !!e.slot.value;
  const specOk = isValidSpecificTime();

  if (e.date) {
    if (!hasDate) {
      e.date.setCustomValidity('Please choose a delivery date.');
    } else if (!isWorkingDate) {
      e.date.setCustomValidity('Delivery is not available on weekends or bank holidays.');
    } else if (!notBeforeMin) {
      e.date.setCustomValidity(`Please choose a date on or after ${new Date(e.date.min + 'T00:00:00').toLocaleDateString('en-GB')}.`);
    } else {
      e.date.setCustomValidity('');
    }
  }

  if (e.timeErr) {
    e.timeErr.textContent =
      (!specOk && slotKey(e.slot.value) === 'specific')
        ? 'Delivery times only between 10:00 and 17:00'
        : '';
  }

  return dateOk && slotOk && specOk;
}

  function setCheckoutEnabled() {
    const e = els();
    if (!e.checkout) return;
    const ok = allValid();
    e.checkout.disabled = !ok;
    e.checkout.style.opacity = ok ? '1' : '0.55';
    e.checkout.style.cursor = ok ? 'pointer' : 'not-allowed';
  }

function hideDeliverySummarySurchargeRows() {
  const summary = document.getElementById('order-summary-items');
  if (!summary) return;

  const surchargeIds = new Set([
    '45887479316643',
    '45887621693603',
    '45887621726371',
    '45887621759139'
  ]);

  const rows = summary.querySelectorAll('.order-summary__item');

  rows.forEach((row) => {
    const variantId = String(row.getAttribute('data-variant-id') || '').trim();
    if (surchargeIds.has(variantId)) {
      row.style.display = 'none';
    }
  });
}

  // ============================================================
  // INIT / REHYDRATE (run after every Minimog cart update)
  // ============================================================
  async function hydrateUI() {
    if (!onCartPage()) return;

    const e = els();

    // cutoff + min date (12:30) using WORKING DAYS, not calendar days
    const now = new Date();
    const cut = new Date(now);
    cut.setHours(12, 30, 0, 0);

    function isNonWorkingDate(d) {
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      return d.getDay() === 0 || d.getDay() === 6 || BANK_HOLIDAYS.has(`${yyyy}-${mm}-${dd}`);
    }

    function nextWorkingDay(d) {
      const x = new Date(d);
      x.setDate(x.getDate() + 1);
      while (isNonWorkingDate(x)) x.setDate(x.getDate() + 1);
      return x;
    }

    let dispatchDate;

    if (isNonWorkingDate(now)) {
      // Weekend orders dispatch next working day
      dispatchDate = new Date(now);
      while (isNonWorkingDate(dispatchDate)) dispatchDate.setDate(dispatchDate.getDate() + 1);
    } else if (now >= cut) {
      // Missed today's cutoff: dispatch next working day
      dispatchDate = nextWorkingDay(now);
    } else {
      // Before cutoff: dispatch today
      dispatchDate = new Date(now);
    }

const earliest = nextWorkingDay(dispatchDate);

const yyyy = earliest.getFullYear();
const mm = String(earliest.getMonth() + 1).padStart(2, '0');
const dd = String(earliest.getDate()).padStart(2, '0');
const disp = `${dd}/${mm}/${yyyy}`;
const wd = earliest.toLocaleDateString('en-GB', { weekday: 'long' });

const earliestValue = `${yyyy}-${mm}-${dd}`;
e.date.min = earliestValue;

if (e.date) {
  const restoredValue = String(e.date.value || '');
  const restoredDate = restoredValue ? new Date(`${restoredValue}T12:00:00`) : null;
  const restoredIsNonWorking = restoredDate && isNonWorkingDate(restoredDate);

  // Keep a valid future customer choice, but never allow an old, missing or
  // weekend browser/cart value to override the calculated earliest date.
  if (!restoredValue || restoredValue < earliestValue || restoredIsNonWorking) {
    e.date.value = earliestValue;
  }
}
  if (e.cutoffMsg) {
  e.cutoffMsg.style.display = 'block';

  if (isNonWorkingDate(now)) {
    const nowValue = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    const nonWorkingCopy = BANK_HOLIDAYS.has(nowValue)
      ? 'Orders placed on the bank holiday will be dispatched on the next working day.'
      : 'Orders placed this weekend will be dispatched on the next working day.';
    e.cutoffMsg.innerHTML = `<span style="color:#22343b;">${nonWorkingCopy}</span> <span style="color:#28a745;">Earliest Delivery: ${disp} (${wd}).</span>`;
  } else if (now >= cut) {
    e.cutoffMsg.innerHTML = `<span style="color:#d9534f;">You’ve missed today’s 12:30 pm cut-off.</span> <span style="color:#28a745;">Earliest Delivery: ${disp} (${wd}).</span>`;
  } else {
    e.cutoffMsg.innerHTML = `<span style="color:#28a745;">Earliest Delivery: ${disp} (${wd}).</span>`;
  }
}

    // hydrate from cart attrs, fallback to localStorage
const cart = await fetchCart();
clearDeliverySessionStateIfCartEmpty(cart);

const a = cart.attributes || {};
const ls = readLocal();

const pick = (key) => (a[key] != null && String(a[key]).length) ? a[key] : (ls[key] || '');

if (e.res)  e.res.value  = pick('clarkes_residential') || e.res.value;
if (e.date) {
  const savedDate = String(pick('clarkes_delivery_date') || '');
  const savedDateObject = savedDate ? new Date(`${savedDate}T12:00:00`) : null;
  const savedDateIsWeekend = savedDateObject && isWeekendDate(savedDateObject);

  // Restore only a currently valid delivery choice. An expired/weekend saved
  // value must not replace the calculated minimum shown to the customer.
  if (savedDate && savedDate >= earliestValue && !savedDateIsWeekend) {
    e.date.value = savedDate;
  } else if (!e.date.value || e.date.value < earliestValue || isWeekendDate(new Date(`${e.date.value}T12:00:00`))) {
    e.date.value = earliestValue;
  }
}

if (e.slot) {
  const savedSlot = pick('clarkes_time_slot');

  if (!deliveryPageLoadInitialised) {
    // Every fresh visit to the delivery step starts on Standard delivery.
    // Set the flag before awaiting so the timed re-hydration calls cannot race
    // and repeatedly reset a choice made on this page.
    deliveryPageLoadInitialised = true;
    setSlotFromLabel(DEFAULT_SLOT_LABEL);
    markDeliverySessionInitialized();

    deliveryPageInitialisationPromise = (async () => {
      // Remove any stale timed-delivery surcharge from an earlier visit.
      await removeAllSurcharges();

      // A second timed hydrate may have read the old cart while the removal was
      // in flight, so assert Standard again before building/saving the state.
      setSlotFromLabel(DEFAULT_SLOT_LABEL);

      // Stamp the cart immediately so checkout and downstream integrations see ND.
      const state = buildStateFromUI();
      writeLocal(state);
      await saveAttrs(state, e.instr?.value || '');
    })();

    try {
      await deliveryPageInitialisationPromise;
    } finally {
      deliveryPageInitialisationPromise = null;
    }
  } else if (deliveryPageInitialisationPromise) {
    // Wait for the first-load reset rather than restoring stale cart attributes.
    await deliveryPageInitialisationPromise;
    setSlotFromLabel(DEFAULT_SLOT_LABEL);
  } else if (savedSlot) {
    // During this page visit, preserve the customer's newly selected upgrade
    // when Minimog redraws the cart DOM.
    setSlotFromLabel(savedSlot);
  } else {
    setSlotFromLabel(DEFAULT_SLOT_LABEL);
  }
}

    if (e.specTime) e.specTime.value = pick('clarkes_specific_time_value') || e.specTime.value;

    if (e.name)  e.name.value  = pick('clarkes_delivery_contact_name') || e.name.value;
    if (e.tel)   e.tel.value   = pick('clarkes_delivery_contact_tel') || e.tel.value;
    if (e.email) e.email.value = pick('clarkes_tracker_email') || e.email.value;
    if (e.hours) e.hours.value = pick('clarkes_opening_hours') || e.hours.value;
    if (e.extDoc) e.extDoc.value = pick('external_document_no') || e.extDoc.value;

    if (e.instr) {
      const instr = pick('clarkes_delivery_instructions');
      e.instr.value = instr || e.instr.value || cart.note || '';
    }

    if (e.weekdayMsg) {
      e.weekdayMsg.textContent = e.date.value
        ? `(${new Date(e.date.value + 'T00:00:00').toLocaleDateString('en-GB', { weekday:'long' })})`
        : '';
    }

toggleSpecificUI();
updateUpgradeSummary();
updateDeliveryOptionPrices();
setCheckoutEnabled();
hideDeliverySummarySurchargeRows();
  }

  // ============================================================
  // SAVE (debounced) – also updates localStorage
  // ============================================================
  let saveTimer = null;
  function queueSave() {
    if (!onCartPage()) return;

    const state = buildStateFromUI();
    writeLocal(state);

    clearTimeout(saveTimer);
    saveTimer = setTimeout(async () => {
      try { await saveAttrs(state, els().instr?.value || ''); } catch {}
    }, 250);
  }

  // ============================================================
  // APPLY SURCHARGE (the injection) – SAVE FIRST to avoid wipe
  // ============================================================
  let applying = false;

  async function applySurchargeForCurrentSlot() {
    if (applying) return;
    if (!onCartPage()) return;

    const e = els();
    const k = slotKey(e.slot.value);

    const variantToAdd =
      (k === 'pre10')    ? SURCHARGE_VARIANTS.pre10 :
      (k === 'am')       ? SURCHARGE_VARIANTS.am :
      (k === 'pm')       ? SURCHARGE_VARIANTS.pm :
      (k === 'specific') ? SURCHARGE_VARIANTS.specific :
      null;

    applying = true;
    e.slot.disabled = true;

    try {
      // 1) save state BEFORE any cart refresh
      const state = buildStateFromUI();
      writeLocal(state);
      await saveAttrs(state, e.instr?.value || '');

      // 2) update cart line items
     await fetch('/cart/update.js', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  credentials: 'same-origin',
  body: JSON.stringify({
    updates: {
      [SURCHARGE_VARIANTS.pre10]: 0,
      [SURCHARGE_VARIANTS.am]: 0,
      [SURCHARGE_VARIANTS.pm]: 0,
      [SURCHARGE_VARIANTS.specific]: 0,
      ...(variantToAdd ? { [variantToAdd]: 1 } : {})
    }
  })
});

      // 3) ask Minimog to redraw cart
      minimogCartRefresh(false);

      // Even if Minimog doesn't fire the event reliably, re-hydrate after redraw
   setTimeout(() => {
  hydrateSoon();
}, 0);

      // hydrate will run on cart:updated
    } finally {
      e.slot.disabled = false;
      applying = false;
    }
  }

  // ============================================================
  // EVENT DELEGATION (survives Minimog DOM replacement)
  // ============================================================
  document.addEventListener('change', async (ev) => {
    if (!onCartPage()) return;

    const t = ev.target;

if (t && (t.id === 'time_slot' || t.name === 'time_slot_radio')) {

  // Sync radio -> hidden input
  if (t.name === 'time_slot_radio') {
    const hidden = document.getElementById('time_slot');
    if (hidden) hidden.value = t.value;
  }

  toggleSpecificUI();
  updateUpgradeSummary();
  setCheckoutEnabled();
  markDeliverySessionInitialized();

  // SAVE + inject surcharge
  await applySurchargeForCurrentSlot();
  return;
}
if (t && t.id === 'delivery_date') {
  const e = els();

  if (e.date.value && isNonWorkingDateValue(e.date.value)) {
    e.date.setCustomValidity('Delivery is not available on weekends or bank holidays.');
    e.date.reportValidity();
    e.date.value = '';
  } else if (e.date.value && isDateBeforeMin(e.date.value, e.date.min)) {
    e.date.setCustomValidity(`Please choose a date on or after ${new Date(e.date.min + 'T00:00:00').toLocaleDateString('en-GB')}.`);
    e.date.reportValidity();
  } else {
    e.date.setCustomValidity('');
  }

  if (e.weekdayMsg) {
    e.weekdayMsg.textContent = e.date.value
      ? `(${new Date(e.date.value + 'T00:00:00').toLocaleDateString('en-GB', { weekday:'long' })})`
      : '';
  }

  setCheckoutEnabled();
  queueSave();
}

});

document.addEventListener('input', (ev) => {
  if (!onCartPage()) return;
  const t = ev.target;

  if (t && t.id === 'delivery_date') {
    const e = els();

    if (e.date.value && isNonWorkingDateValue(e.date.value)) {
      e.date.setCustomValidity('Delivery is not available on weekends or bank holidays.');
    } else if (e.date.value && isDateBeforeMin(e.date.value, e.date.min)) {
      e.date.setCustomValidity(`Please choose a date on or after ${new Date(e.date.min + 'T00:00:00').toLocaleDateString('en-GB')}.`);
    } else {
      e.date.setCustomValidity('');
    }

    if (e.weekdayMsg) {
      e.weekdayMsg.textContent = e.date.value
        ? `(${new Date(e.date.value + 'T00:00:00').toLocaleDateString('en-GB', { weekday:'long' })})`
        : '';
    }

    setCheckoutEnabled();
    queueSave();
    return;
  }

  if (t && t.id === 'specific_time') {
    const state = buildStateFromUI();
    writeLocal(state);
    setCheckoutEnabled();
    return;
  }

  const ids = new Set([
    'delivery_contact_name',
    'delivery_contact_tel',
    'tracker_email',
    'opening_hours',
    'external_document_no',
    'delivery_instructions'
  ]);

  if (t && ids.has(t.id)) {
    setCheckoutEnabled();
    queueSave();
  }
});

  /* ===============================
   Specific Time Save on Finish
=================================*/

document.addEventListener('change', (ev) => {
  if (!onCartPage()) return;
  const t = ev.target;

  if (t && t.id === 'specific_time') {
    setCheckoutEnabled();
    queueSave();
  }
});

document.addEventListener('blur', (ev) => {
  if (!onCartPage()) return;
  const t = ev.target;

  if (t && t.id === 'specific_time') {
    setCheckoutEnabled();
    queueSave();
  }
}, true);

document.addEventListener('click', async (ev) => {
  if (!onCartPage()) return;

  const btn = ev.target.closest('#custom-checkout-btn, #delivery-continue-btn');
  if (!btn) return;

  // Stop native checkout link/button action first.
  // This is critical on mobile, especially if the checkout button is an <a href="/checkout">.
  ev.preventDefault();
  ev.stopPropagation();

  if (!allValid()) {
    const e = els();

    if (e.date && !e.date.checkValidity()) {
      e.date.reportValidity();
      e.date.focus();
    }

    const sec = document.querySelector('[data-delivery-details]');
    if (sec) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });

    return;
  }

  btn.disabled = true;

  try {
    // final sync
    const state = buildStateFromUI();
    writeLocal(state);
    await saveAttrs(state, els().instr?.value || '');

    // ensure surcharge matches the slot
    await applySurchargeForCurrentSlot();

    window.location.href = '/checkout';
  } finally {
    setTimeout(() => { btn.disabled = false; }, 600);
  }
});

// ------------------------------------------------------------
// Robust re-hydration after Minimog redraws cart DOM
// (Minimog event names can differ by version)
// ------------------------------------------------------------
let hydrateQueue = Promise.resolve();

function queueHydrateUI() {
  hydrateQueue = hydrateQueue
    .catch(() => {})
    .then(() => hydrateUI())
    .catch((error) => {
      console.warn('[FRK Delivery] Could not hydrate delivery UI:', error);
    });

  return hydrateQueue;
}

function hydrateSoon() {
  if (isTypingSpecificTime()) {
    updateDeliveryOptionPrices();
    hideDeliverySummarySurchargeRows();
    return;
  }

  queueHydrateUI();
  updateDeliveryOptionPrices();
  hideDeliverySummarySurchargeRows();

  setTimeout(() => {
    if (!isTypingSpecificTime()) queueHydrateUI();
    updateDeliveryOptionPrices();
    hideDeliverySummarySurchargeRows();
  }, 250);

  setTimeout(() => {
    if (!isTypingSpecificTime()) queueHydrateUI();
    updateDeliveryOptionPrices();
    hideDeliverySummarySurchargeRows();
  }, 800);
}

window.addEventListener('vat:modeChanged', () => {
  if (!onCartPage()) return;
  updateDeliveryOptionPrices();
  hideDeliverySummarySurchargeRows();
});

document.addEventListener('cart:updated', hydrateSoon);
document.addEventListener('cart:refresh', hydrateSoon);
document.addEventListener('shopify:section:load', hydrateSoon);

// Initial hydrate
hydrateSoon();
});

// ============================================================
// FRK: Free delivery progress bar (£400 threshold) - Cart Drawer
// Excludes delivery surcharge line items from the subtotal.
// If a ROOFING KIT is in cart, FREE delivery is instantly unlocked.
// If any other "kit" is in cart (non-roofing), logic remains intact.
// Display updated:
// - Roofing kit: title shows unlock message
// - No roofing kit + not unlocked: title rotates between threshold + roofing kit prompt
// - Spend threshold reached: title shows unlocked state
// ============================================================
(function () {
  const THRESHOLD_GBP = 400;
  const WIDGET_ID = 'frk-free-ship-widget';

  const SURCHARGE_VARIANT_IDS = new Set([
    45887479316643,
    45887621693603,
    45887621726371,
    45887621759139
  ]);
  const SURCHARGE_PRODUCT_TYPE = 'Delivery Surcharge';

  const ROOFING_KIT_PRODUCT_TYPES = new Set([
    'Roofing Kits',
    'Roof Kits'
  ]);

const ANY_KIT_MATCH = /kit/i;

const VAT_RATE = 0.20;

function isSurcharge(it) {
  const variantId = Number(it.variant_id || it.id || 0);
  const type = String(it.product_type || it.product?.type || '').trim().toLowerCase();
  const title = String(it.product_title || it.title || '').trim().toLowerCase();

  if (SURCHARGE_VARIANT_IDS.has(variantId)) return true;
  if (type === SURCHARGE_PRODUCT_TYPE.toLowerCase()) return true;

  if (
    title === 'pre 10am' ||
    title === 'before 10am' ||
    title === 'am delivery' ||
    title === 'morning (before 12pm)' ||
    title === 'pm delivery' ||
    title === 'afternoon (after 12pm)' ||
    title === 'specific time' ||
    title.includes('delivery upgrade')
  ) {
    return true;
  }

  return false;
}

function getVatMode() {
  const htmlMode = (document.documentElement.getAttribute('data-vat-mode') || '').trim().toLowerCase();
  const bodyMode = (document.body.getAttribute('data-vat-mode') || '').trim().toLowerCase();

  if (htmlMode === 'ex' || htmlMode === 'inc' || htmlMode === 'both') return htmlMode;
  if (bodyMode === 'ex' || bodyMode === 'inc' || bodyMode === 'both') return bodyMode;

  try {
    const keys = [
      'vat_mode',
      'frk_vat_mode',
      'grp_vat_mode',
      'vat-display-mode',
      'vatDisplayMode'
    ];

    for (const key of keys) {
      const value = (localStorage.getItem(key) || '').trim().toLowerCase();
      if (value === 'ex' || value === 'inc' || value === 'both') return value;
    }
  } catch (e) {}

  return 'inc';
}

function formatCartAmount(amount) {
  return new Intl.NumberFormat('en-GB', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number(amount || 0));
}

function fmtGBPByVatMode(n) {
  const v = Math.max(0, Number(n || 0));
  const mode = getVatMode();

  if (mode === 'ex') {
    return '£' + formatCartAmount(v);
  }

  return '£' + formatCartAmount(v * (1 + VAT_RATE));
}

  const getDrawerRoot = () =>
    document.querySelector('.m-cart-drawer') ||
    document.querySelector('[data-cart-drawer]') ||
    null;

  const getDrawerBody = () => {
    return (
      document.querySelector('.m-cart-drawer__content') ||
      document.querySelector('.m-cart-drawer .m-cart-drawer__body') ||
      document.querySelector('.m-cart-drawer__body') ||
      getDrawerRoot()
    );
  };

  const ensureWidget = () => {
    const body = getDrawerBody();
    if (!body) return null;

    let el = document.getElementById(WIDGET_ID);
    if (el) return el;

    el = document.createElement('div');
    el.id = WIDGET_ID;
    el.className = 'frk-free-ship';
    el.innerHTML = `
      <div class="frk-free-ship__row">
        <div class="frk-free-ship__title" data-frk-title>Unlock FREE Delivery at £400 (ex VAT)</div>
        <div class="frk-free-ship__meta" data-frk-meta></div>
      </div>
      <div class="frk-free-ship__bar">
        <div class="frk-free-ship__fill" data-frk-fill></div>
      </div>
      <div class="frk-free-ship__msg" data-frk-msg></div>
    `;

    const itemsWrap =
      document.querySelector('.m-cart-drawer__items') ||
      document.querySelector('#MinimogCartDrawerBody .m-cart-drawer__items') ||
      document.querySelector('#MinimogCartDrawerBody form') ||
      body.firstElementChild;

    if (itemsWrap && itemsWrap.parentNode) {
      itemsWrap.parentNode.insertBefore(el, itemsWrap);
    } else if (body.firstChild) {
      body.insertBefore(el, body.firstChild);
    } else {
      body.appendChild(el);
    }

    return el;
  };

  let debounceTimer = null;
  let frkRotateTimer = null;

const scheduleUpdate = (delay = 80) => {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(update, delay);
};
  const stopTitleRotation = () => {
    if (frkRotateTimer) {
      clearInterval(frkRotateTimer);
      frkRotateTimer = null;
    }
  };

const startTitleRotation = (titleEl) => {
  if (!titleEl) return;

  const slides = [
    'Unlock <strong>FREE</strong> Delivery at £400 (ex VAT)',
    '<strong>FREE</strong> Delivery on all Roofing Kits'
  ];

  const existingSlides = titleEl.__frkSlides;
  if (
    frkRotateTimer &&
    existingSlides &&
    existingSlides.length === slides.length &&
    existingSlides.every((v, i) => v === slides[i])
  ) {
    return;
  }

  stopTitleRotation();

  let index = 0;
  titleEl.__frkSlides = slides;
  titleEl.innerHTML = slides[index];
  titleEl.classList.remove('is-animating');

  frkRotateTimer = window.setInterval(() => {
    titleEl.classList.add('is-animating-out');

    setTimeout(() => {
      index = (index + 1) % slides.length;
      titleEl.innerHTML = slides[index];
      titleEl.classList.remove('is-animating-out');
      titleEl.classList.add('is-animating-in');

      setTimeout(() => {
        titleEl.classList.remove('is-animating-in');
      }, 320);
    }, 220);
  }, 3200);
};

  const update = async () => {
    const el = ensureWidget();
    if (!el) return;

    let cart;
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      cart = await res.json();
    } catch {
      stopTitleRotation();
      el.style.display = 'none';
      return;
    }

    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
      stopTitleRotation();
      el.style.display = 'none';
      return;
    }

let subtotalPence = 0;
let hasAnyKit = false;
let hasRoofingKit = false;

if (cart && Array.isArray(cart.items)) {
  for (const it of cart.items) {
   const ptype = (it.product_type || '').trim();
const title = (it.product_title || '').trim();

if (isSurcharge(it)) {
  continue;
}

  const line = Number(
  it.final_line_price ??
  it.line_price ??
  ((it.final_price || it.price || 0) * (it.quantity || 1)) ??
  0
);

subtotalPence += line;

    if (ANY_KIT_MATCH.test(ptype) || ANY_KIT_MATCH.test(title)) {
      hasAnyKit = true;
    }

    if (ROOFING_KIT_PRODUCT_TYPES.has(ptype) || /roof(ing)?\s*kit/i.test(title)) {
      hasRoofingKit = true;
    }
  }
}

subtotalPence = Math.max(0, subtotalPence);

    const subtotal = subtotalPence / 100;
    const remaining = hasRoofingKit ? 0 : (THRESHOLD_GBP - subtotal);
    const pct = hasRoofingKit
      ? 100
      : Math.max(0, Math.min(100, (subtotal / THRESHOLD_GBP) * 100));

    const title = el.querySelector('[data-frk-title]');
    const meta = el.querySelector('[data-frk-meta]');
    const fill = el.querySelector('[data-frk-fill]');
    const msg = el.querySelector('[data-frk-msg]');

    el.style.display = '';
    fill.style.width = pct.toFixed(2) + '%';

    if (hasRoofingKit) {
      stopTitleRotation();
      title.innerHTML = 'Free delivery unlocked with your <strong>Roofing Kit</strong>.';
      meta.textContent = 'Unlocked';
      msg.innerHTML = `✅ Free delivery unlocked with your <strong>roofing kit</strong>.`;
      return;
    }

    if (remaining > 0.009) {
      startTitleRotation(title);
    const vatMode = getVatMode();

meta.textContent =
  vatMode === 'inc'
    ? `${fmtGBPByVatMode(remaining)} (inc VAT) to go`
    : `${fmtGBPByVatMode(remaining)} to go`;

      if (hasAnyKit) {
        msg.innerHTML =
          `Add a <strong>roofing kit</strong> to unlock <strong>FREE delivery</strong> instantly — or spend <strong>${fmtGBPByVatMode(remaining)}</strong> more to unlock at <strong>${fmtGBPByVatMode(THRESHOLD_GBP)}</strong> (${getVatMode() === 'ex' ? 'ex VAT' : 'inc VAT'}).`;
      } else {
        msg.innerHTML =
          `Spend <strong>${fmtGBPByVatMode(remaining)}</strong> more to unlock <strong>FREE delivery</strong> at <strong>${fmtGBPByVatMode(THRESHOLD_GBP)}</strong> (${getVatMode() === 'ex' ? 'ex VAT' : 'inc VAT'}).`;
      }
    } else {
      stopTitleRotation();
      title.innerHTML = 'FREE delivery unlocked';
      meta.textContent = 'Unlocked';
      msg.innerHTML = `✅ You’ve unlocked <strong>FREE delivery</strong>.`;
    }
  };

scheduleUpdate(150);
  document.addEventListener('cart:open', () => scheduleUpdate(150));
  document.addEventListener('cart:refresh', () => scheduleUpdate(150));
  document.addEventListener('cart:updated', () => scheduleUpdate(150));
  document.addEventListener('ajaxProduct:added', () => scheduleUpdate(250));
  document.addEventListener('shopify:section:load', () => scheduleUpdate(300));

window.addEventListener('vat:modeChanged', () => {
  update();
});

  const installObserver = () => {
    const root = getDrawerRoot();
    if (!root || root.__frkFreeShipObserved) return;

    root.__frkFreeShipObserved = true;

    const obs = new MutationObserver(() => scheduleUpdate(250));
    obs.observe(root, { childList: true, subtree: true });

    root.addEventListener('click', (e) => {
      const btn = e.target.closest('button, a');
      if (!btn) return;
      scheduleUpdate(400);
    });
  };

  setTimeout(installObserver, 500);
  document.addEventListener('cart:open', () => setTimeout(installObserver, 150));
})();

// ============================================================
// FRK: Cart drawer delivery charge + total
// VAT-aware summary matching the site's VAT toggle
// ============================================================
(function () {
  const WIDGET_ID = 'frk-ship-estimate-widget';

  const HAZ_TAG = 'has_un';
  const SMALL_PARCEL_MAX_KG = 30;
  const PARCELFORCE_PRICE = 6.00;
  const FREE_THRESHOLD = 400;
  const VAT_RATE = 0.20;

  const CLARKES_BANDS = [
    { min: 0, max: 25, price: 15 },
    { min: 25.01, max: 35, price: 19 },
    { min: 35.01, max: 50, price: 21 },
    { min: 50.01, max: 75, price: 27 },
    { min: 75.01, max: 100, price: 31 },
    { min: 100.01, max: 9999, price: 33 }
  ];

  const SURCHARGE_VARIANT_IDS = new Set([
    45887479316643,
    45887621693603,
    45887621726371,
    45887621759139
  ]);

  const SURCHARGE_PRODUCT_TYPE = 'Delivery Surcharge';

  function getFooterWrapper() {
    return (
      document.querySelector('.m-cart-drawer__footer--wrapper') ||
      document.querySelector('.cart-drawer__footer--wrapper') ||
      document.querySelector('.m-cart-drawer__footer')
    );
  }

  function ensureWidget() {
    const wrapper = getFooterWrapper();
    if (!wrapper) return null;

    let el = document.getElementById(WIDGET_ID);
    if (el) return el;

    el = document.createElement('div');
    el.id = WIDGET_ID;
    el.className = 'frk-ship-estimate';
    el.style.display = 'none';

    el.innerHTML = `
      <div class="frk-ship-estimate__row">
        <span class="frk-ship-estimate__label">Items</span>
        <strong class="frk-ship-estimate__value" data-subtotal></strong>
      </div>

      <div class="frk-ship-estimate__row">
        <span class="frk-ship-estimate__label">Delivery</span>
        <strong class="frk-ship-estimate__value" data-delivery></strong>
      </div>

      <div class="frk-ship-estimate__row" data-discount-row style="display:none;">
        <span class="frk-ship-estimate__label-wrap">
          <span class="frk-ship-estimate__label">Discounts</span>
          <span class="frk-ship-estimate__subtext">5% off first order</span>
        </span>
        <strong class="frk-ship-estimate__value" data-discount></strong>
      </div>
    `;

    wrapper.insertBefore(el, wrapper.firstChild);
    return el;
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return res.json();
  }

  function hasTag(item, tag) {
    let tags = item.product_tags || item.tags || [];
    if (typeof tags === 'string') tags = tags.split(',');

    return tags
      .map(t => String(t).trim().toLowerCase())
      .includes(String(tag).toLowerCase());
  }

  function isTrim(item) {
    const type = String(item.product_type || '').trim().toLowerCase();
    if (type === 'trims') return true;
    if (hasTag(item, 'Trim')) return true;
    return false;
  }

  function isSurcharge(item) {
    const variantId = Number(item.variant_id || item.id || 0);
    if (SURCHARGE_VARIANT_IDS.has(variantId)) return true;

    const type = String(item.product_type || item.product?.type || '').trim().toLowerCase();
    const title = String(item.product_title || item.title || '').trim().toLowerCase();

    if (type === SURCHARGE_PRODUCT_TYPE.toLowerCase()) return true;

    if (
      title === 'pre 10am' ||
      title === 'before 10am' ||
      title === 'am delivery' ||
      title === 'morning (before 12pm)' ||
      title === 'pm delivery' ||
      title === 'afternoon (after 12pm)' ||
      title === 'specific time' ||
      title.includes('delivery upgrade')
    ) {
      return true;
    }

    return false;
  }

  function calcWeight(cart) {
    let kg = 0;
    for (const item of cart.items || []) {
      if (isSurcharge(item)) continue;
      kg += ((item.grams || 0) * item.quantity) / 1000;
    }
    return kg;
  }

  function bandPrice(bands, weight) {
    const band = bands.find(b => weight >= b.min && weight <= b.max);
    return band ? band.price : 0;
  }

  function hasRoofingKit(cart) {
    for (const item of cart.items || []) {
      if (isSurcharge(item)) continue;

      const type = String(item.product_type || '').trim().toLowerCase();
      let tags = item.product_tags || item.tags || [];
      if (typeof tags === 'string') tags = tags.split(',');

      const normTags = tags.map(t => String(t).trim().toLowerCase());

      if (type === 'roofing kits' || type === 'roof kits') return true;
      if (normTags.includes('roofing kits') || normTags.includes('roof kits')) return true;
    }

    // /cart.js does not always expose product tags, but the Liquid cart rows do.
    const domItems = document.querySelectorAll('[data-cart-item]');
    for (const el of domItems) {
      const type = String(el.getAttribute('data-product-type') || '').trim().toLowerCase();
      const tags = String(el.getAttribute('data-product-tags') || '')
        .split(',')
        .map(tag => tag.trim().toLowerCase())
        .filter(Boolean);

      if (type === 'roofing kits' || type === 'roof kits') return true;
      if (tags.includes('roofing kits') || tags.includes('roof kits')) return true;
    }

    return false;
  }

  function getMerchandiseTotalsExVat(cart) {
    let originalSubtotalPence = 0;
    let finalSubtotalPence = 0;
    let discountPence = 0;

    for (const item of cart.items || []) {
      if (isSurcharge(item)) continue;

      const originalLine = Number(
        item.original_line_price ??
        ((item.original_price || item.price || 0) * (item.quantity || 1)) ??
        0
      );

      const finalLine = Number(
        item.final_line_price ??
        item.line_price ??
        ((item.final_price || item.price || 0) * (item.quantity || 1)) ??
        0
      );

      originalSubtotalPence += originalLine;
      finalSubtotalPence += finalLine;
      discountPence += Math.max(0, originalLine - finalLine);
    }

    const cartDiscountPence = Number(cart.total_discount ?? 0);
    const extraCartLevelDiscountPence = Math.max(0, cartDiscountPence - discountPence);

    finalSubtotalPence = Math.max(0, finalSubtotalPence - extraCartLevelDiscountPence);

    return {
      originalSubtotalExVat: originalSubtotalPence / 100,
      finalSubtotalExVat: finalSubtotalPence / 100,
      discountExVat: (discountPence + extraCartLevelDiscountPence) / 100
    };
  }

  function freeDeliveryQualifies(cart) {
    const totals = getMerchandiseTotalsExVat(cart);

    return (
      totals.finalSubtotalExVat >= FREE_THRESHOLD ||
      hasRoofingKit(cart)
    );
  }

  function decideDeliveryChargeExVat(cart) {
    if (freeDeliveryQualifies(cart)) {
      return { price: 0 };
    }

    let hasHaz = false;
    let hasTrimItems = false;

    for (const item of cart.items || []) {
      if (isSurcharge(item)) continue;

      if (hasTag(item, HAZ_TAG)) hasHaz = true;
      if (isTrim(item)) hasTrimItems = true;
    }

    const cartDomItems = document.querySelectorAll('[data-cart-item]');
    for (const el of cartDomItems) {
      const hazUn = String(el.getAttribute('data-haz-un') || '').trim();
      const type = String(el.getAttribute('data-product-type') || '').trim().toLowerCase();
      const tags = String(el.getAttribute('data-product-tags') || '')
        .split(',')
        .map(tag => tag.trim().toLowerCase())
        .filter(Boolean);

      if (hazUn !== '' || tags.includes(HAZ_TAG)) hasHaz = true;
      if (type === 'trims' || tags.includes('trim')) hasTrimItems = true;
    }

    const weight = calcWeight(cart);

    if (hasHaz) return { price: bandPrice(CLARKES_BANDS, weight) };
    if (hasTrimItems) return { price: bandPrice(CLARKES_BANDS, weight) };
    if (weight <= SMALL_PARCEL_MAX_KG) return { price: PARCELFORCE_PRICE };

    return { price: bandPrice(CLARKES_BANDS, weight) };
  }

  function getVatMode() {
    const htmlMode = (document.documentElement.getAttribute('data-vat-mode') || '').trim().toLowerCase();
    const bodyMode = (document.body.getAttribute('data-vat-mode') || '').trim().toLowerCase();

    if (htmlMode === 'ex' || htmlMode === 'inc' || htmlMode === 'both') return htmlMode;
    if (bodyMode === 'ex' || bodyMode === 'inc' || bodyMode === 'both') return bodyMode;

    try {
      const keys = [
        'vat_mode',
        'frk_vat_mode',
        'grp_vat_mode',
        'vat-display-mode',
        'vatDisplayMode'
      ];

      for (const key of keys) {
        const value = (localStorage.getItem(key) || '').trim().toLowerCase();
        if (value === 'ex' || value === 'inc' || value === 'both') return value;
      }
    } catch (e) {}

    return 'inc';
  }

  function formatCartAmount(amount) {
    return new Intl.NumberFormat('en-GB', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(Number(amount || 0));
  }

  function renderVatValue(amountExVat, mode) {
    const amountIncVat = amountExVat * 1.2;

    if (mode === 'ex') {
      return `
        <span class="vat-display vat-display--single">
          <span class="vat-main">£${formatCartAmount(amountExVat)}</span>
          <span class="vat-pill">ex. VAT</span>
        </span>
      `;
    }

    if (mode === 'both') {
      return `
        <span class="vat-display vat-display--both">
          <span class="vat-main">£${formatCartAmount(amountIncVat)}</span>
          <span class="vat-sub">
            <span class="vat-pill">inc. VAT</span>
          </span>
          <span class="vat-sub">
            <span class="vat-sub__price">£${formatCartAmount(amountExVat)}</span>
            <span class="vat-pill">ex. VAT</span>
          </span>
        </span>
      `;
    }

    return `
      <span class="vat-display vat-display--single">
        <span class="vat-main">£${formatCartAmount(amountIncVat)}</span>
        <span class="vat-pill">inc. VAT</span>
      </span>
    `;
  }

  function renderNegativeVatValue(amountExVat, mode) {
    const amountIncVat = amountExVat * 1.2;

    if (mode === 'ex') {
      return `
        <span class="vat-display vat-display--single">
          <span class="vat-main">-£${formatCartAmount(amountExVat)}</span>
          <span class="vat-pill">ex. VAT</span>
        </span>
      `;
    }

    if (mode === 'both') {
      return `
        <span class="vat-display vat-display--both">
          <span class="vat-main">-£${formatCartAmount(amountIncVat)}</span>
          <span class="vat-sub">
            <span class="vat-pill">inc. VAT</span>
          </span>
          <span class="vat-sub">
            <span class="vat-sub__price">-£${formatCartAmount(amountExVat)}</span>
            <span class="vat-pill">ex. VAT</span>
          </span>
        </span>
      `;
    }

    return `
      <span class="vat-display vat-display--single">
        <span class="vat-main">-£${formatCartAmount(amountIncVat)}</span>
        <span class="vat-pill">inc. VAT</span>
      </span>
    `;
  }

  function renderFree(mode) {
    return `
      <span class="vat-display vat-display--single">
        <span class="vat-main">FREE</span>
      </span>
    `;
  }

  function getCartUpgradeExVat(cart) {
    for (const item of cart.items || []) {
      if (!isSurcharge(item)) continue;

      const pricePerUnit = (item.original_price || item.price || 0);
      return pricePerUnit / 100;
    }
    return 0;
  }

function formatGBP(amount) {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number(amount || 0));
}

function updateCheckoutButtonTotal(totalExVat, vatMode) {
  const btn = document.querySelector('.m-cart-drawer a.m-button--primary');
  if (!btn) return;

  const totalAmount = vatMode === 'ex'
    ? totalExVat
    : totalExVat * 1.2;

  const totalText = new Intl.NumberFormat('en-GB', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number(totalAmount || 0));

  btn.innerHTML = `<span class="frk-cart-checkout__label">Continue to delivery</span><span class="frk-cart-checkout__total">£${totalText}</span>`;
  btn.setAttribute('aria-label', `Continue to delivery. Estimated total £${totalText}`);
}

  function toggleNativeSubtotal(hide) {
    const wrapper = getFooterWrapper();
    if (!wrapper) return;

    const nativeSummary = wrapper.querySelector('.m-cart__summary.m-cart-drawer__summary');
    if (nativeSummary) {
      nativeSummary.style.display = hide ? 'none' : '';
    }
  }

  function isCartDrawerOpen() {
    const drawer = document.getElementById('MinimogCartDrawer');
    if (!drawer) return false;

    return (
      drawer.classList.contains('m-cart-drawer--active') ||
      drawer.classList.contains('active') ||
      drawer.getAttribute('aria-hidden') === 'false'
    );
  }

  let standardResetPromise = null;

  async function resetCartToStandard(cart, refreshDrawer = false) {
    if (standardResetPromise) return standardResetPromise;

    const updates = {};
    for (const item of cart.items || []) {
      if (!isSurcharge(item)) continue;
      const variantId = Number(item.variant_id || item.id || 0);
      if (variantId) updates[variantId] = 0;
    }

    const attrs = cart.attributes || {};
    const needsAttributeReset =
      String(attrs.clarkes_time_slot || '') !== 'Standard delivery' ||
      String(attrs.clarkes_specific_time_value || '') !== '' ||
      String(attrs.clarkes_service_level || '') !== 'ND';

    if (!Object.keys(updates).length && !needsAttributeReset) return cart;

    const nextAttributes = {
      ...attrs,
      clarkes_time_slot: 'Standard delivery',
      clarkes_specific_time_value: '',
      clarkes_service_level: 'ND'
    };

    try {
      const saved = JSON.parse(localStorage.getItem('grp_delivery_state_v2') || '{}');
      localStorage.setItem('grp_delivery_state_v2', JSON.stringify({
        ...saved,
        clarkes_time_slot: 'Standard delivery',
        clarkes_specific_time_value: '',
        clarkes_service_level: 'ND'
      }));
    } catch (e) {}

    standardResetPromise = fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        ...(Object.keys(updates).length ? { updates } : {}),
        attributes: nextAttributes
      })
    })
      .then(res => {
        if (!res.ok) throw new Error(`Cart update failed: ${res.status}`);
        return fetchCart();
      })
      .then(freshCart => {
        if (refreshDrawer && Object.keys(updates).length) {
          document.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { open: true }
          }));
        }
        return freshCart;
      })
      .finally(() => {
        standardResetPromise = null;
      });

    return standardResetPromise;
  }

  async function update() {
    const el = ensureWidget();
    if (!el) return;

    let cart;
    try {
      cart = await fetchCart();
    } catch (e) {
      el.style.display = 'none';
      toggleNativeSubtotal(false);
      return;
    }

    if (!cart.items || !cart.items.length) {
      el.style.display = 'none';
      toggleNativeSubtotal(false);
      return;
    }

    // The cart drawer always represents STANDARD delivery. If an upgrade was
    // left in the cart from a previous visit to the delivery step, remove it
    // when the drawer is actually opened (never while the customer is actively
    // choosing an upgrade on the delivery page).
    if (isCartDrawerOpen()) {
      try {
        cart = await resetCartToStandard(cart, true);
      } catch (e) {
        // Keep showing a standard estimate even if Shopify momentarily rejects
        // the cleanup request; the delivery step will retry the reset on entry.
      }
    }

    const vatMode = getVatMode();
    const merchTotals = getMerchandiseTotalsExVat(cart);

    const itemsSubtotalExVat = merchTotals.originalSubtotalExVat;
    const discountedItemsSubtotalExVat = merchTotals.finalSubtotalExVat;
    const discountExVat = merchTotals.discountExVat;

    const baseDeliveryExVat = decideDeliveryChargeExVat(cart).price;
    const deliveryExVat = baseDeliveryExVat;

    const totalExVat = discountedItemsSubtotalExVat + deliveryExVat;

    el.style.display = '';
    toggleNativeSubtotal(true);

    el.querySelector('[data-subtotal]').innerHTML = renderVatValue(itemsSubtotalExVat, vatMode);
    el.querySelector('[data-delivery]').innerHTML =
      deliveryExVat > 0 ? renderVatValue(deliveryExVat, vatMode) : renderFree(vatMode);

    const discountRow = el.querySelector('[data-discount-row]');
    const discountValue = el.querySelector('[data-discount]');

    if (discountRow && discountValue) {
      if (discountExVat > 0) {
        discountRow.style.display = '';
        discountValue.innerHTML = renderNegativeVatValue(discountExVat, vatMode);
      } else {
        discountRow.style.display = 'none';
        discountValue.innerHTML = '';
      }
    }

    updateCheckoutButtonTotal(totalExVat, vatMode);
  }

  let timer;
  function schedule(delay = 80) {
    clearTimeout(timer);
    timer = setTimeout(update, delay);
  }

  schedule(80);
  document.addEventListener('cart:open', () => schedule(40));
  document.addEventListener('cart:updated', () => schedule(80));
  document.addEventListener('cart:refresh', () => schedule(80));
  document.addEventListener('ajaxProduct:added', () => schedule(120));
  document.addEventListener('shopify:section:load', () => schedule(120));

  document.addEventListener('click', async (event) => {
    const link = event.target.closest('#MinimogCartDrawer .frk-cart-checkout[href="/delivery-details"]');
    if (!link) return;

    event.preventDefault();
    link.setAttribute('aria-busy', 'true');

    try {
      const cart = await fetchCart();
      await resetCartToStandard(cart, false);
    } catch (e) {
      // The delivery page also performs the same reset, so navigation remains safe.
    } finally {
      window.location.href = link.href;
    }
  });

  const drawer = document.getElementById('MinimogCartDrawer');
  if (drawer && 'MutationObserver' in window) {
    new MutationObserver(() => {
      if (isCartDrawerOpen()) schedule(40);
    }).observe(drawer, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
  }

  window.addEventListener('vat:modeChanged', () => {
    update();
  });

  setTimeout(() => schedule(150), 150);
})();

// ============================================================
// FRK: Delivery details page order summary
// Mirrors cart drawer logic, but splits base delivery and upgrade
// ============================================================
(function () {
  const HAZ_TAG = 'has_un';
  const SMALL_PARCEL_MAX_KG = 30;
  const PARCELFORCE_PRICE = 6.00;
  const FREE_THRESHOLD = 400;
  const VAT_RATE = 0.20;

  const CLARKES_BANDS = [
    { min: 0, max: 25, price: 15 },
    { min: 25.01, max: 35, price: 19 },
    { min: 35.01, max: 50, price: 21 },
    { min: 50.01, max: 75, price: 27 },
    { min: 75.01, max: 100, price: 31 },
    { min: 100.01, max: 9999, price: 33 }
  ];

  const SURCHARGE_VARIANT_IDS = new Set([
    45887479316643,
    45887621693603,
    45887621726371,
    45887621759139
  ]);

  const SURCHARGE_PRODUCT_TYPE = 'Delivery Surcharge';

  function onDeliveryPage() {
    return !!document.querySelector('[data-delivery-details]');
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return res.json();
  }

  function hasTag(item, tag) {
    let tags = item.product_tags || item.tags || [];
    if (typeof tags === 'string') tags = tags.split(',');

    return tags
      .map(t => String(t).trim().toLowerCase())
      .includes(String(tag).toLowerCase());
  }

  function isTrim(item) {
    const type = String(item.product_type || '').trim().toLowerCase();
    if (type === 'trims') return true;
    if (hasTag(item, 'Trim')) return true;
    return false;
  }

function isSurcharge(item) {
  const variantId = Number(item.variant_id || item.id || 0);
  return SURCHARGE_VARIANT_IDS.has(variantId);
}

  function calcWeight(cart) {
    let kg = 0;
    for (const item of cart.items || []) {
      if (isSurcharge(item)) continue;
      kg += ((item.grams || 0) * item.quantity) / 1000;
    }
    return kg;
  }

  function bandPrice(bands, weight) {
    const band = bands.find(b => weight >= b.min && weight <= b.max);
    return band ? band.price : 0;
  }

  function hasRoofingKit(cart) {
    for (const item of cart.items || []) {
      if (isSurcharge(item)) continue;

      const type = String(item.product_type || '').trim().toLowerCase();
      let tags = item.product_tags || item.tags || [];
      if (typeof tags === 'string') tags = tags.split(',');

      const normTags = tags.map(t => String(t).trim().toLowerCase());

      if (type === 'roofing kits' || type === 'roof kits') return true;
      if (normTags.includes('roofing kits') || normTags.includes('roof kits')) return true;
    }

    // /cart.js does not always expose product tags, but the Liquid cart rows do.
    const domItems = document.querySelectorAll('[data-cart-item]');
    for (const el of domItems) {
      const type = String(el.getAttribute('data-product-type') || '').trim().toLowerCase();
      const tags = String(el.getAttribute('data-product-tags') || '')
        .split(',')
        .map(tag => tag.trim().toLowerCase())
        .filter(Boolean);

      if (type === 'roofing kits' || type === 'roof kits') return true;
      if (tags.includes('roofing kits') || tags.includes('roof kits')) return true;
    }

    return false;
  }
function getMerchandiseTotalsExVat(cart) {
  let originalSubtotalPence = 0;
  let finalSubtotalPence = 0;
  let itemLevelDiscountPence = 0;

  for (const item of cart.items || []) {
    if (isSurcharge(item)) continue;

    const originalLine = Number(
      item.original_line_price ??
      ((item.original_price || item.price || 0) * (item.quantity || 1)) ??
      0
    );

    const finalLine = Number(
      item.final_line_price ??
      item.line_price ??
      ((item.final_price || item.price || 0) * (item.quantity || 1)) ??
      0
    );

    originalSubtotalPence += originalLine;
    finalSubtotalPence += finalLine;
    itemLevelDiscountPence += Math.max(0, originalLine - finalLine);
  }

  // Shopify cart.total_discount is the reliable value shown in the cart drawer.
  // Use it for the custom checkout discount row as well.
  const totalDiscountPence = Number(cart.total_discount || 0);

  return {
    originalSubtotalExVat: originalSubtotalPence / 100,
    finalSubtotalExVat: Math.max(0, originalSubtotalPence - totalDiscountPence) / 100,
    discountExVat: totalDiscountPence / 100
  };
}

function freeDeliveryQualifies(cart) {
  const totals = getMerchandiseTotalsExVat(cart);

  return (
    totals.finalSubtotalExVat >= FREE_THRESHOLD ||
    hasRoofingKit(cart)
  );
}

  function decideBaseDeliveryChargeExVat(cart) {
    if (freeDeliveryQualifies(cart)) {
      return 0;
    }

    let hasHaz = false;
    let hasTrimItems = false;

    for (const item of cart.items || []) {
      if (isSurcharge(item)) continue;

      if (hasTag(item, HAZ_TAG)) hasHaz = true;
      if (isTrim(item)) hasTrimItems = true;
    }

    const cartDomItems = document.querySelectorAll('[data-cart-item]');
    for (const el of cartDomItems) {
      const hazUn = String(el.getAttribute('data-haz-un') || '').trim();
      const type = String(el.getAttribute('data-product-type') || '').trim().toLowerCase();
      const tags = String(el.getAttribute('data-product-tags') || '')
        .split(',')
        .map(tag => tag.trim().toLowerCase())
        .filter(Boolean);

      if (hazUn !== '' || tags.includes(HAZ_TAG)) hasHaz = true;
      if (type === 'trims' || tags.includes('trim')) hasTrimItems = true;
    }

    const weight = calcWeight(cart);

    if (hasHaz) return bandPrice(CLARKES_BANDS, weight);
    if (hasTrimItems) return bandPrice(CLARKES_BANDS, weight);
    if (weight <= SMALL_PARCEL_MAX_KG) return PARCELFORCE_PRICE;

    return bandPrice(CLARKES_BANDS, weight);
  }

  function getVatMode() {
    const htmlMode = (document.documentElement.getAttribute('data-vat-mode') || '').trim().toLowerCase();
    const bodyMode = (document.body.getAttribute('data-vat-mode') || '').trim().toLowerCase();

    if (htmlMode === 'ex' || htmlMode === 'inc' || htmlMode === 'both') return htmlMode;
    if (bodyMode === 'ex' || bodyMode === 'inc' || bodyMode === 'both') return bodyMode;

    try {
      const keys = [
        'vat_mode',
        'frk_vat_mode',
        'grp_vat_mode',
        'vat-display-mode',
        'vatDisplayMode'
      ];

      for (const key of keys) {
        const value = (localStorage.getItem(key) || '').trim().toLowerCase();
        if (value === 'ex' || value === 'inc' || value === 'both') return value;
      }
    } catch (e) {}

    return 'inc';
  }

  function formatCartAmount(amount) {
  return new Intl.NumberFormat('en-GB', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number(amount || 0));
}

function renderVatValue(amountExVat, mode) {
  const amountIncVat = amountExVat * (1 + VAT_RATE);

  if (mode === 'ex') {
    return `
      <span class="vat-display vat-display--single">
        <span class="vat-main">£${formatCartAmount(amountExVat)}</span>
        <span class="vat-pill">ex. VAT</span>
      </span>
    `;
  }

  if (mode === 'both') {
    return `
      <span class="vat-display vat-display--both">
        <span class="vat-main">£${formatCartAmount(amountIncVat)}</span>
        <span class="vat-sub">
          <span class="vat-pill">inc. VAT</span>
        </span>
        <span class="vat-sub">
          <span class="vat-sub__price">£${formatCartAmount(amountExVat)}</span>
          <span class="vat-pill">ex. VAT</span>
        </span>
      </span>
    `;
  }

  return `
    <span class="vat-display vat-display--single">
      <span class="vat-main">£${formatCartAmount(amountIncVat)}</span>
      <span class="vat-pill">inc. VAT</span>
    </span>
  `;
}

  function renderFree(mode) {
    if (mode === 'both') {
      return `
        <span class="vat-display vat-display--single">
          <span class="vat-main">FREE</span>
        </span>
      `;
    }

    return `
      <span class="vat-display vat-display--single">
        <span class="vat-main">FREE</span>
      </span>
    `;
  }
  
  function renderNegativeVatValue(amountExVat, mode) {
  const amountIncVat = amountExVat * 1.2;

  if (mode === 'ex') {
    return `
      <span class="vat-display vat-display--single">
        <span class="vat-main">-£${formatCartAmount(amountExVat)}</span>
        <span class="vat-pill">ex. VAT</span>
      </span>
    `;
  }

  if (mode === 'both') {
    return `
      <span class="vat-display vat-display--both">
        <span class="vat-main">-£${formatCartAmount(amountIncVat)}</span>
        <span class="vat-sub">
          <span class="vat-pill">inc. VAT</span>
        </span>
        <span class="vat-sub">
          <span class="vat-sub__price">-£${formatCartAmount(amountExVat)}</span>
          <span class="vat-pill">ex. VAT</span>
        </span>
      </span>
    `;
  }

  return `
    <span class="vat-display vat-display--single">
      <span class="vat-main">-£${formatCartAmount(amountIncVat)}</span>
      <span class="vat-pill">inc. VAT</span>
    </span>
  `;
}

function getSelectedUpgradeExVat(cart) {
  for (const item of cart.items || []) {
    if (!isSurcharge(item)) continue;

    const pricePerUnit = (item.original_price || item.price || 0);
    return pricePerUnit / 100;
  }
  return 0;
}

function updateCheckoutButton(totalExVat, vatMode) {
  const btn = document.getElementById('delivery-continue-btn');
  if (!btn) return;

  const totalAmount = vatMode === 'ex'
    ? totalExVat
    : totalExVat * 1.2;

  const totalText = new Intl.NumberFormat('en-GB', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number(totalAmount || 0));

  btn.textContent = `Continue to payment · £${totalText}`;
}

  function hidePageSummarySurchargeRows() {
  const summary = document.getElementById('order-summary-items');
  if (!summary) return;

  const surchargeIds = new Set([
    '45887479316643',
    '45887621693603',
    '45887621726371',
    '45887621759139'
  ]);

  summary.querySelectorAll('.order-summary__item').forEach((row) => {
    const variantId = String(row.getAttribute('data-variant-id') || '').trim();
    if (surchargeIds.has(variantId)) {
      row.style.display = 'none';
    }
  });
}

async function updateDeliverySummary() {
  if (!onDeliveryPage()) return;

  let cart;
  try {
    cart = await fetchCart();
  } catch (e) {
    return;
  }

  const subtotalEl = document.getElementById('order-subtotal');
  const deliveryEl = document.getElementById('order-delivery');
  const upgradeEl = document.getElementById('order-delivery-upgrade');
  const upgradeCaptionEl = document.getElementById('order-delivery-upgrade-caption');
  const deliveryRow = document.getElementById('order-delivery-row');
  const upgradeRow = document.getElementById('order-delivery-upgrade-row');
  const totalEl = document.getElementById('order-total');

const discountRow = document.getElementById('order-discount-row');
const discountEl = document.getElementById('order-discount');
const discountCaptionEl = document.getElementById('order-discount-caption');

  if (!subtotalEl || !deliveryEl || !upgradeEl) return;

  const vatMode = getVatMode();

 const merchTotals = getMerchandiseTotalsExVat(cart);
const itemsSubtotalExVat = merchTotals.originalSubtotalExVat;
const discountExVat = merchTotals.discountExVat;

const baseDeliveryExVat = decideBaseDeliveryChargeExVat(cart);
const upgradeExVat = getSelectedUpgradeExVat(cart);

// Match cart drawer / Shopify logic:
// items subtotal + base delivery + delivery upgrade - discount
const totalExVat = Math.max(
  0,
  itemsSubtotalExVat + baseDeliveryExVat + upgradeExVat - discountExVat
);
  const slot = (document.getElementById('time_slot')?.value || '').toLowerCase();

  subtotalEl.innerHTML = renderVatValue(itemsSubtotalExVat, vatMode);

  if (deliveryRow) deliveryRow.style.display = '';
  deliveryEl.innerHTML = baseDeliveryExVat > 0
    ? renderVatValue(baseDeliveryExVat, vatMode)
    : renderFree(vatMode);

if (discountRow && discountEl) {
  if (discountExVat > 0) {
    discountRow.style.display = '';
    discountEl.innerHTML = renderNegativeVatValue(discountExVat, vatMode);

    if (discountCaptionEl) {
      discountCaptionEl.textContent = '5% off first order';
    }
  } else {
    discountRow.style.display = 'none';
    discountEl.innerHTML = '';

    if (discountCaptionEl) {
      discountCaptionEl.textContent = '';
    }
  }
}

  let upgradeCaption = '';
  if (slot.includes('pre 10') || slot.includes('before 10')) {
    upgradeCaption = 'Before 10am';
  } else if (slot.includes('morning') || slot === 'am' || slot.includes('am delivery')) {
    upgradeCaption = 'Morning (before 12pm)';
  } else if (slot.includes('afternoon') || slot === 'pm' || slot.includes('pm delivery')) {
    upgradeCaption = 'Afternoon (after 12pm)';
  } else if (slot.includes('specific')) {
    upgradeCaption = 'Specific time';
  }

  if (upgradeExVat > 0) {
    if (upgradeRow) upgradeRow.style.display = '';
    upgradeEl.innerHTML = renderVatValue(upgradeExVat, vatMode)
      .replace('<span class="vat-main">', '<span class="vat-main">+');
    if (upgradeCaptionEl) upgradeCaptionEl.textContent = upgradeCaption;
  } else {
    if (upgradeRow) upgradeRow.style.display = 'none';
    upgradeEl.innerHTML = '';
    if (upgradeCaptionEl) upgradeCaptionEl.textContent = '';
  }

  if (totalEl) {
    totalEl.innerHTML = renderVatValue(totalExVat, vatMode);
  }

  updateCheckoutButton(totalExVat, vatMode);
  hidePageSummarySurchargeRows();
}

let deliverySummaryTimer1;
let deliverySummaryTimer2;
let deliverySummaryTimer3;

function scheduleUpdate() {
  clearTimeout(deliverySummaryTimer1);
  clearTimeout(deliverySummaryTimer2);
  clearTimeout(deliverySummaryTimer3);

  updateDeliverySummary();
  deliverySummaryTimer1 = setTimeout(updateDeliverySummary, 150);
  deliverySummaryTimer2 = setTimeout(updateDeliverySummary, 400);
  deliverySummaryTimer3 = setTimeout(updateDeliverySummary, 800);
}

scheduleUpdate();
document.addEventListener('change', (ev) => {
  if (ev.target && ev.target.id === 'specific_time') return;
  scheduleUpdate();
});

document.addEventListener('input', (ev) => {
  if (ev.target && ev.target.id === 'specific_time') return;
  scheduleUpdate();
});
  document.addEventListener('cart:updated', scheduleUpdate);
  document.addEventListener('cart:refresh', scheduleUpdate);
  document.addEventListener('shopify:section:load', scheduleUpdate);


window.addEventListener('vat:modeChanged', () => {
  scheduleUpdate();
});
})();